import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="app-footer">
      <p>&copy; {currentYear} Constellation KG LLC. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
